import React, { ReactNode } from 'react';
import styles from './button.module.scss';
import SpinningLoader from '../spinning-loader/spinning-loader';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  loading?: boolean;
  className?: string;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
}

const Button: React.FC<IButtonProps> = ({
  children,
  loading,
  className,
  disabled,
  variant = 'primary',
  ...restProps
}) => {
  const loaderColor = variant === 'primary' ? '#ffffff' : '#1b244d';

  return (
    <button
      className={`${styles.base} ${styles[variant]} ${loading && styles.loading} ${className || ''}`}
      disabled={disabled}
      aria-busy={loading}
      {...restProps}
    >
      {loading ? (
        <SpinningLoader height="22px" width="22px" color={loaderColor} />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
